import { UseFormRegisterReturn } from "react-hook-form";
import { cn } from "@/utils/classes";
import { cva, type VariantProps } from "class-variance-authority";

/* Variants */
const variants = cva("radio", {
  variants: {
    variant: {
      default: "radio-neutral",
      primary: "radio-primary",
      secondary: "radio-secondary",
      accent: "radio-accent",
    },
    size: {
      sm: "radio-sm",
      md: "radio-md",
      lg: "radio-lg",
    },
    error: {
      true: "radio-error",
      false: "",
    },
  },
  defaultVariants: {
    size: "md",
    variant: "default",
  },
});

/* Prop Types */
interface RadioButtonProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">, Omit<VariantProps<typeof variants>, "error"> {
  label?: string;
  error?: string | boolean;
  registration?: UseFormRegisterReturn;
  className?: string;
  variant?: VariantProps<typeof variants>["variant"];
  size?: VariantProps<typeof variants>["size"];
}

/*
 * RadioButton Component
 */
export const RadioButton = ({ label, error, registration, className = "", variant, size, ...props }: RadioButtonProps) => {
  /* Render */
  return (
    <fieldset className="fieldset">
      <label className="label cursor-pointer justify-start">
        <input type="radio" className={cn(variants({ variant, size, error: !!error, className }))} {...registration} {...props} />
        {label && <span className="ml-1 text-sm text-neutral">{label}</span>}
      </label>
      {error && (
        <label className="label">
          <span className="text-error">{error}</span>
        </label>
      )}
    </fieldset>
  );
};
